import { MpsBaseRepository } from './mps-base-repository';

export class MpsRepository<T extends { id: number }> extends MpsBaseRepository<T> {
  constructor(primaryKey?: keyof T, timestampFields?: { createdAt?: keyof T; updatedAt?: keyof T }) {
    super(primaryKey, timestampFields);
  }
  public fill(data: T[]): void {
    this.mockData = data;
  }
  public findById(id: any): T | undefined {
    return this.mockData.find((item) => item.id === id);
  }

  public findByKey(key: keyof T, value: any): T | undefined {
    return this.mockData.find((item) => item[key] === value);
  }

  public findAll(): T[] {
    return this.mockData;
  }

  public findPage(page: number, pageSize: number): T[] {
    const startIndex = (page - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return this.mockData.slice(startIndex, endIndex);
  }

  public create(item: Partial<T>): T {
    const id = this.nextPrimaryKey();
    // Check if T has a createdAt field and set it
    const createdAt =
      this.timestampFields?.createdAt && (item as any)[this.timestampFields.createdAt] !== undefined
        ? new Date()
        : undefined;
    const updatedAt =
      this.timestampFields?.updatedAt && (item as any)[this.timestampFields.updatedAt] !== undefined
        ? new Date()
        : undefined;
    const newItem = { ...item, id: id, ...(createdAt && { createdAt }), ...(updatedAt && { updatedAt }) } as unknown as T;
    this.mockData.push(newItem);
    return newItem;
  }

  public update(id: any, item: Partial<T>): T | undefined {
    const index = this.mockData.findIndex((item) => item.id === id);
    if (index !== -1) {
      const updatedAt =
        this.timestampFields?.updatedAt && (this.mockData[index] as any)[this.timestampFields.updatedAt] !== undefined
          ? new Date()
          : undefined;
      this.mockData[index] = { ...this.mockData[index], ...item, ...(updatedAt && { updatedAt }) };
      return this.mockData[index];
    }
    return undefined;
  }

  public delete(id: any): void {
    const index = this.mockData.findIndex((item) => item.id === id);
    if (index !== -1) {
      this.mockData.splice(index, 1);
    }
  }

  public nextPrimaryKey(): number {
    return this.mockData.length > 0 ? Math.max(...this.mockData.map((item) => item.id)) + 1 : 1;
  }
}
